import React from 'react';
import { PhoneNumber } from './detail_snippets.js';
import {formatAddress, trackClick} from '../util/util.js';

const trackExternalClick = (item, isCommunity, reportingTrackingPath, trackingEnabled, listHubProviderId) => {
    if (isCommunity) {
        fetch(reportingTrackingPath + ';pc=451');
    } else {
        fetch(reportingTrackingPath + ';pc=207');
        fetch(reportingTrackingPath + ';pc=492');
        if (trackingEnabled) {
            try {
                if (item.listhub_key && listHubProviderId) {
                    const _lh = new window.ListHubTracker({provider: listHubProviderId, test: false});
                    _lh.submit('OFFICE_WEBSITE_CLICKED', item.listhub_key);
                }
            } catch(err) {console.log('listHub error' + err)}
        }
    }
}


function BrandingAgentCommunity ({item, affiliate, fullName, enhancedAgent, isCommunity, mini = false}) {
        const premier = item.premier_listing && item.premier_listing.toUpperCase() === 'ON';
        const showLogo = enhancedAgent || !!item.showcase_home || !!premier || isCommunity;
        const photoUrl = isCommunity
            ? item.community_logo
            : item.agent_logo_90_90;
        const displayName = isCommunity
            ? item.community_name
            : !!item.agent_first_name && !!item.agent_last_name
                ? `${item.agent_first_name} ${item.agent_last_name}`
                : ' ';
        // construct the Agent/Community branding. If there is no displayName, there is nothing to show.
        return displayName
                ? mini
                    ? <div className="agent-community-mini">{displayName}</div>
                    : (
                        <div className="agent-community">
                            {photoUrl && showLogo
                                ? (<div className="agent-photo">
                                       <img className="agent-logo" alt="" src={photoUrl.replace('http://images-re','https://images-re')}/>
                                   </div>)
                                : <div className="agent-photo-placeholder"></div>}
                            {!!displayName &&
                                <div className="agent-name">{displayName}</div>
                            }
                            {!isCommunity && (enhancedAgent || item.showcase_home) &&
                                <div className="view-listings">
                                    <a
                                        href={"https://realestate." + fullName + ".com/?temp_type=browse&classification=directory&tp=" + affiliate + "&property=" + fullName + ".com&customer_id=" + item.agent_id + "&tl=3&xref=agent"}
                                        onClick={() => {
                                            trackClick('dp_view_agent_listing_click',`view_agent_listing_click: ${item.agent_id}`);
                                        }}
                                    >
                                        View All My Listings
                                    </a>
                                </div>
                            }
                        </div>
                      )
                : null
}

function BrandingBrokerManager({item, affiliate, fullName, enhancedBroker, isCommunity, reportingTrackingPath, mapAddress,
                                trackingEnabled, listHubProviderId, mini = false}) {
        const premier = item.premier_listing && item.premier_listing.toUpperCase() === 'ON';
        const showLogo = enhancedBroker || !!item.showcase_home || !!premier || isCommunity;
        const logoUrl = item.property_management_logo || item.broker_logo_135_60;
        const link = item.community_url || item.broker_url;
        const phoneNumbers = [
            {label: "Phone", value: item.broker_day_phone || item.agent_day_phone || item.community_phone || item.property_management_phone},
            {label: "Mobile", value: item.agent_cell_number},
            {label: "Fax", value: item.agent_fax_number || item.broker_fax_number}
        ];
        const businessName = item.broker_business_name || item.property_management_name
        const companyInfo = isCommunity && `${mapAddress || ''} ${formatAddress(item.city, item.state, item.zipcode)}`;
        // construct the Broker/Manager element. If there is no businessName, there is nothing to show.
        return businessName
                ? mini
                    ? <div className="broker-manager-mini">{businessName}</div>
                    : (
                        <div className="broker-manager">
                            {logoUrl && showLogo &&
                                <div className="broker-logo">
                                    <a
                                        href={link}
                                        rel="nofollow"
                                        target="_community"
                                        onClick={() => trackExternalClick(item, isCommunity, reportingTrackingPath,
                                                                         trackingEnabled, listHubProviderId)}
                                    >
                                        <img src={logoUrl.replace('http://images-re','https://images-re')} alt={businessName}/>
                                    </a>
                                </div>
                            }
                            <div className="business-name">{businessName}</div>
                            {!!companyInfo &&
                                <div className="company-info">{companyInfo}</div>
                            }
                            {!isCommunity &&
                                <div className="view-listings">
                                    <a
                                        href={"https://realestate." + fullName + ".com/?temp_type=browse&classification=directory&tp=" + affiliate + "&property=" + fullName + ".com&broker_customerid=" + item.broker_id + "&tl=3&xref=broker"}
                                        onClick={() => {
                                            trackClick('dp_view_broker_listing_click',`view_broker_listing_click: ${item.broker_id}`);
                                        }}
                                    >
                                        View All Our Listings
                                    </a>
                                </div>
                            }
                            <div className="phone-numbers">
                                {phoneNumbers.map((item, key) => (
                                    <PhoneNumber
                                        key={key}
                                        label={item.label}
                                        number={item.value}
                                    />))}
                            </div>
                            {!!item.office_hours &&
                                <div className="office-hours">
                                    <h3>Office Hours</h3>
                                    <p>{item.office_hours}</p>
                                </div>
                            }
                        </div>
                      )
                : null
        }

export {BrandingAgentCommunity, BrandingBrokerManager };
